import React, { useEffect, useState } from "react"
import axios from "axios"
import config from "config/config"
import CreateNewSurveyCampaign from "./CreateNewSurveyCampaign"
import "./index.css" // Import custom CSS for full-page loader
import { useLocation } from "react-router-dom"
import CampaignForm from "./CampaignForm"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  Input,
  Label,
  Form,
  CardTitle,
  Table,
  Tooltip,
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup" // For validation schema
import Select from "react-select"
import { useSelector, connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import SnackbarComponent from "components/SnackBar"
import SurveyForm from "./SurveyForm"
import NewSurveyForm from "./NewSurveyForm"
import IconButton from "components/Common/IconButton/IconButton"
import PrimaryButton from "newcomponents/primary-button"
import TemplatePicker from "./TemplatePicker"

const CreateCampaign = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)

  document.title = "Campaign | Reputation Management"

  const breadcrumbItems = [
    { title: `${activeOrganization.name}`, link: "#" },
    { title: "Surveys", link: "/survey-dashboard" },
    { title: "Create Campaign", link: "#" },
  ]
  const mode = useSelector(state => state.Layout.layoutMode)
  const [categories, setCategories] = useState([])
  const [audience, setAudience] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])
  const [newCategories, setNewCategories] = useState([])
  const [templates, setTemplates] = useState([])
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(true)
  const [mostAvailedServices, setMostAvailedServices] = useState({})
  const [customers, setCustomers] = useState([])
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [audienceModalOpen, setAudienceModalOpen] = useState(false)
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    organizationId: activeOrganization.id,
    survey: [],
    campaign: {
      cycle: "",
      frequency: "",
      campaignTitle: "",
      campaignDescription: "",
      startDate: "",
      endDate: "",
      status: "active",
    },
  })

  useEffect(() => {
    props.setBreadcrumbItems(`Create Campaign`, breadcrumbItems)
  }, [])

  const validationSchema = Yup.object().shape({
    audienceName: Yup.string().required("Audience Name is required"),
    audienceDescription: Yup.string().required(
      "Audience Description is required",
    ),
  })

  const fetchCustomers = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${config.backendUrl}/customers/${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setCustomers(response.data.customers)

      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchAudience = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${config.backendUrl}/audience/getOrganizationAudience/${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setAudience(response.data.audiences)
      setLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchCampaign = async () => {
    try {
      const campaignResponse = await axios.get(
        `${config.backendUrl}/survey/getCampaign?distributionId=${location.state.campaignId}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      const campaignData = campaignResponse.data.campaign
      console.log("Fetched Campaign Data:", campaignData)

      // Extract all audiences from SurveyDistributions

      // Convert date format to YYYY-MM-DD for input fields
      const formattedStartDate = campaignData.startDate
        ? campaignData.startDate.split("T")[0]
        : ""
      const formattedEndDate = campaignData.endDate
        ? campaignData.endDate.split("T")[0]
        : ""

      // Set campaign data in form state
      setFormData(prevState => ({
        ...prevState,
        campaign: {
          id: campaignData.id,
          campaignTitle: campaignData.campaignTitle,
          campaignDescription: campaignData.campaignDescription,
          frequency: campaignData.frequency,
          cycle: campaignData.cycle,
          startDate: formattedStartDate, // Fixed Date Format
          endDate: formattedEndDate, // Fixed Date Format
        },
      }))

      console.log("Updated Form Data:", formData)
    } catch (err) {
      console.error("Error fetching campaign data:", err)
    }
  }

  const fetchTemplates = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${config.backendUrl}/survey/getOrganizationTemplates/${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setTemplates(response.data.templates)
      setLoading(false)
    } catch (err) {
      console.log(err)
      setErr("Error fetching templates.")
    }
  }

  useEffect(() => {
    if (location?.state?.campaignId) {
      fetchCampaign()
    }
    fetchTemplates()
    // fetchCategories()
    fetchAudience()
    fetchCustomers()
  }, [props.campaignId])

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(null)
      }, 3000)
    }
    if (err) {
      setTimeout(() => {
        setErr(null)
      }, 3000)
    }
  }, [success, err])

  const handleAudienceChange = selectedOptions => {
    console.log("Audience Selected:", selectedOptions)

    // Extract audience IDs (if needed elsewhere)
    const selectedAudiences = selectedOptions.map(option => option.value)

    setFormData(prevState => ({
      ...prevState,
      campaign: {
        ...prevState.campaign,
        audiences: selectedOptions, // Keep full `{ value, label }`
      },
    }))
  }

  const calculateMostAvailedServices = () => {
    if (!Array.isArray(customers)) {
      console.warn("Customers is not an array or is null")
      return
    }

    const servicesCountMap = {}

    customers.forEach(customer => {
      const visits = customer.CustomerVisits || []
      const serviceCount = {}

      if (visits.length === 0) {
        servicesCountMap[customer.id] = "No visits"
        return
      }

      visits.forEach(visit => {
        const service = visit.service
        if (service) {
          serviceCount[service] = (serviceCount[service] || 0) + 1
        }
      })

      if (Object.keys(serviceCount).length > 0) {
        const mostAvailedService = Object.entries(serviceCount).reduce(
          (prev, current) => (current[1] > prev[1] ? current : prev),
          ["", 0],
        )[0]

        servicesCountMap[customer.id] = mostAvailedService
      } else {
        servicesCountMap[customer.id] = "N/A"
      }
    })

    setMostAvailedServices(servicesCountMap)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    const { survey, campaign } = formData
    const {
      campaignTitle,
      campaignDescription,
      startDate,
      endDate,
      frequency,
      cycle,
    } = campaign

    console.log("formData", formData)
    const hasEmptySurveyFields = survey.some(s => {
      return !s.title.trim() || !s.description.trim()
    })

    if (hasEmptySurveyFields) {
      setLoading(false)
      setErr("All survey fields must be filled, including audiences.")
      return
    }
    if (!campaignTitle.trim()) {
      setLoading(false)
      setErr("Campaign title is required.")
      return
    }
    if (campaignTitle.length < 5) {
      setLoading(false)
      setErr("Campaign title must be at least 5 characters long.")
      return
    }
    if (campaignTitle.length > 50) {
      setLoading(false)
      setErr("Campaign title cannot exceed 50 characters.")
      return
    }

    if (!campaignDescription.trim()) {
      setLoading(false)
      setErr("Campaign description is required.")
      return
    }
    if (campaignDescription.length < 50) {
      setLoading(false)
      setErr("Campaign description must be at least 50 characters long.")
      return
    }
    if (campaignDescription.length > 500) {
      setLoading(false)
      setErr("Campaign description cannot exceed 500 characters.")
      return
    }

    const today = new Date().toISOString().split("T")[0]
    if (!startDate) {
      setLoading(false)
      setErr("Enter start date for your campaign.")
      return
    }
    if (startDate < today) {
      setLoading(false)
      setErr("Start date cannot be in the past.")
      return
    }
    if (!endDate) {
      setLoading(false)
      setErr("Enter end date for your campaign.")
      return
    }
    if (endDate < startDate) {
      setLoading(false)
      setErr("End date cannot be before the start date.")
      return
    }
    if (!cycle.trim()) {
      setLoading(false)
      setErr("Cycle selection is required.")
      return
    }
    if (frequency === "" || frequency === null) {
      setLoading(false)
      setErr("Frequency is required.")
      return
    }
    if (frequency < 0 || frequency > 2) {
      setLoading(false)
      setErr("Frequency must be between 0 and 2.")
      return
    }

    const updatedFormData = {
      ...formData,
      survey: survey.map(s => ({ ...s })),
    }

    try {
      const response = await axios.post(
        `${config.backendUrl}/survey/createDistribution`,
        updatedFormData,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setFormData({
        campaign: {
          cycle: "",
          frequency: "",
          campaignTitle: "",
          campaignDescription: "",
          startDate: "",
          endDate: "",
          audiences: [],
        },
        survey: [],
      })

      setSuccess("Survey Distribution Started")
      navigate("/dashboard/campaign")
    } catch (err) {
      setErr("Error creating survey distribution.")
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const toggleTemplateModal = () => {
    setIsTemplateModalOpen(prev => !prev)
  }

  const colors = {
    cardBg: mode === "dark" ? "#252F40" : "#FFFFFF",
    text: mode === "dark" ? "#FFFFFF" : "#252F40",
    muted: mode === "dark" ? "#B9C0CA" : "#6B7280",
    iconBg: mode === "dark" ? "rgba(255,255,255,0.08)" : "#F1F1F1",
    iconFg: "#2990DF",
    up: "#58DB83",
    down: "#EF4444",
    badgeBg: mode === "dark" ? "rgba(88,219,131,0.12)" : "#E6F8EE",
  }

  // Handle template selection
  const handleTemplateSelection = template => {
    console.log("Selected Template:", template)

    // Transform the nested `SurveyCategory[] -> SurveyQuestions[]` into expected format
    const formattedQuestions = template.SurveyCategories.flatMap(category =>
      category.SurveyQuestions.map(question => ({
        questionText: question.questionText,
        questionType: question.questionType,
        questionOptions: question?.options || [], // Ensure options exist
        category: category.name, // Extract category name
      })),
    )

    // Add a new survey object from the template (disable editing)
    setFormData(prevState => ({
      ...prevState,
      survey: [
        ...prevState.survey,
        {
          surveyId: template.id,
          title: `${template.title}-Copy`,
          description: template.description,
          questions: formattedQuestions, // ✅ Use transformed questions
          audiences: [], // Empty for user input
          isTemplate: true, // Flag to disable title & description
        },
      ],
    }))

    toggleTemplateModal() // Close modal after selection
  }

  const toggleAudienceModal = () => {
    setAudienceModalOpen(!audienceModalOpen)
    calculateMostAvailedServices()
  }

  return (
    <>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />

      <Form onSubmit={handleSubmit} className="form-horizontal">
        <CampaignForm
          formData={formData}
          setFormData={setFormData}
          colors={colors}
          mode={mode}
        />
        <NewSurveyForm
          formData={formData}
          setFormData={setFormData}
          setErr={setErr}
          setSuccess={setSuccess}
          colors={colors}
          mode={mode}
        />
        <SurveyForm
          formData={formData}
          setFormData={setFormData}
          toggleTemplateModal={toggleTemplateModal}
          colors={colors}
          mode={mode}
        />
        <Modal
          isOpen={isTemplateModalOpen}
          toggle={toggleTemplateModal}
          centered
          style={{
            maxWidth: "500px",
            zIndex: 1200,
          }}
        >
          <div
            style={{
              backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
              borderRadius: "12px",
              padding: "0",
            }}
          >
            <ModalHeader
              toggle={toggleTemplateModal}
              style={{
                backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
                color: mode === "dark" ? "#fff" : "#000",
                fontWeight: "600",
                fontSize: "18px",
                borderBottom:
                  mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
                paddingBottom: "16px",
              }}
            >
              Select a Template
            </ModalHeader>
            <ModalBody
              style={{
                backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
                textAlign: "center",
                padding: "30px 40px",
              }}
            >
              {templates.length > 0 ? (
                <TemplatePicker
                  templates={templates}
                  mode={mode}
                  onSelect={handleTemplateSelection}
                />
              ) : (
                <p>No templates available.</p>
              )}
            </ModalBody>
            <ModalFooter
              style={{
                // backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
                paddingVertical: "10px",
                paddingHorizontal: "40px",
                justifyContent: "center",
                gap: "12px",
                borderTop:
                  mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
              }}
            >
              <PrimaryButton
                onClick={toggleTemplateModal}
                style={{
                  backgroundColor: "white",
                  border:
                    mode === "dark" ? "1px solid #374151" : "1px solid #e0e0e0",
                  color: mode === "dark" ? "#000" : "#000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "166px",
                  height: "46px",
                  minWidth: "120px",
                  borderRadius: "5px",
                }}
              >
                Cancel
              </PrimaryButton>
            </ModalFooter>
          </div>
        </Modal>
        <Row className="justify-content-center">
          <Col xl={12}>
            <Card className="shadow-sm br">
              <CardBody>
                <Row className="align-items-center">
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    className="d-flex justify-content-center align-items-center gap-2"
                  >
                    <Button
                      color="primary"
                      type="submit"
                      style={{
                        backgroundColor: "#2990DF",
                        color: "white",
                        border: mode === "dark" ? "#252f40" : "#fff",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        padding: "10px 30px",
                        fontSize: "15px",
                        fontWeight: "500",
                        borderRadius: "8px",
                      }}
                    >
                      Start Campaign
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => navigate("/dashboard/campaign")}
                      style={{
                        padding: "10px 30px",
                        fontSize: "15px",
                        fontWeight: "500",
                        borderRadius: "8px",
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default connect(null, { setBreadcrumbItems })(CreateCampaign)
